import { render, staticRenderFns } from "./InventoryOnHandList.vue?vue&type=template&id=0f7b4075"
import script from "./InventoryOnHandList.vue?vue&type=script&lang=js"
export * from "./InventoryOnHandList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports